




















import { Component, Vue, Prop } from 'vue-property-decorator';
import CopyButton from '@/components/Utilities/CopyButton.vue';
import { State } from 'vuex-class';
import openbitlab from '@/types.d';
import { get } from 'lodash';

@Component({
  components: {
    CopyButton,
  },
})
export default class ToolBadge extends Vue {
  @State('tools') tools!: openbitlab.RootState['tools']

  @Prop({ required: true }) readonly t!: string

  get tool(): openbitlab.Tool {
    return get(this.tools, this.t);
  }
}
